import * as React from 'react'
import { ISettingItem } from '../../types'

interface ISettingRemoveErrorContentProps {
  setting: ISettingItem
  error: string
  onClose: () => void
}

const SettingRemoveErrorContent = (props: ISettingRemoveErrorContentProps) => (
  <>
    <div className='h5 center'>{props.error}</div>
    <div className='mb1 h5 mr1'>Name 1</div>
    <div className='right-align mt1'>
      <button className='p1 font-grey h5 bg-white border-white mr1' onClick={props.onClose}>
        Close
      </button>
    </div>
  </>
)

export default SettingRemoveErrorContent



// WEBPACK FOOTER //
// ./src/components/global-settings/SettingRemoveErrorContent.tsx